import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const AgentCommandContext = createContext(null);

export const AgentCommandProvider = ({ children }) => {
  const [version, setVersion] = useState(0);
  const commandsRef = useRef(new Map());

  const registerCommand = useCallback((id, callback) => {
    if (!id || typeof callback !== 'function') return;
    commandsRef.current.set(id, callback);
    setVersion((prev) => prev + 1);
  }, []);

  const unregisterCommand = useCallback((id) => {
    if (!id) return;
    if (commandsRef.current.delete(id)) setVersion((prev) => prev + 1);
  }, []);

  const getCommand = useCallback((id) => commandsRef.current.get(id), []);

  const value = useMemo(() => ({ registerCommand, unregisterCommand, getCommand, commandVersion: version }), [registerCommand, unregisterCommand, getCommand, version]);

  return <AgentCommandContext.Provider value={value}>{children}</AgentCommandContext.Provider>;
};

export const useAgentCommands = () => {
  const context = useContext(AgentCommandContext);
  if (!context) throw new Error('useAgentCommands must be used within an AgentCommandProvider');
  return context;
};
